import { apiClient } from '@/shared/api/apiClient';
import {
  handleRequest,
  type RequestHandlerOptions,
} from '@/shared/api/apiWrapper';
import type {
  ClearRegistrationProcessRequestDto,
  ClearRegistrationProcessResponseDto,
  CreateAccountRequestDto,
  CreateAccountResponseDto,
  RegistrationEulaRequestDto,
  RegistrationEulaResponseDto,
  RegistrationInfoResponseDto,
  RegistrationStartRequestDto,
  RegistrationStartResponseDto,
  SendRegistrationIdentityCodeRequestDto,
  SendRegistrationIdentityCodeResponseDto,
  VerifyRegistrationIdentityCodeRequestDto,
  VerifyRegistrationIdentityCodeResponseDto,
} from './types';
import { getUtmHeader } from '@/shared/lib';

const getRegistrationInfo = async (
  state: string,
  options?: RequestHandlerOptions
) => {
  const request = () =>
    apiClient.get('/users/registration/info', {
      params: {
        state,
      },
    });
  const response = await handleRequest<RegistrationInfoResponseDto>(
    request,
    options
  );
  return response.data;
};

const startRegistration = async (body: RegistrationStartRequestDto = {}) => {
  const request = () =>
    apiClient.post('/users/registration/start', body, {
      headers: {
        f2x_utm: getUtmHeader(),
      },
    });
  const response = await handleRequest<RegistrationStartResponseDto>(request);
  return response.data;
};

const getRegistrationEula = async (registrationState: string) => {
  const request = () =>
    apiClient.get('/users/registration/eula', {
      params: {
        state: registrationState,
      },
    });
  const response = await handleRequest<RegistrationEulaResponseDto>(request);
  return response.data;
};

const postRegistrationEula = async (args: RegistrationEulaRequestDto) => {
  const request = () => apiClient.post('/users/registration/eula', args);
  const response = await handleRequest<{
    stepId: string;
  }>(request);
  return response.data;
};

const sendRegistrationIdentityCode = async (
  args: SendRegistrationIdentityCodeRequestDto
) => {
  const request = () => apiClient.post('/users/registration/send', args);
  const response =
    await handleRequest<SendRegistrationIdentityCodeResponseDto>(request);
  return response.data;
};

const verifyRegistrationIdentityCode = async (
  args: VerifyRegistrationIdentityCodeRequestDto,
  options?: RequestHandlerOptions
) => {
  const request = () => apiClient.post('/users/registration/verify', args);
  const response =
    await handleRequest<VerifyRegistrationIdentityCodeResponseDto>(
      request,
      options
    );
  return response.data;
};

const createAccount = async (args: CreateAccountRequestDto) => {
  const request = () => apiClient.post('/users/registration/create', args);
  const response = await handleRequest<CreateAccountResponseDto>(request);
  return response.data;
};

const clearRegistrationProcess = async (
  args: ClearRegistrationProcessRequestDto
) => {
  const request = () => apiClient.post('/users/registration/clear', args);
  const response =
    await handleRequest<ClearRegistrationProcessResponseDto>(request);
  return response.data;
};

export {
  getRegistrationInfo,
  startRegistration,
  getRegistrationEula,
  postRegistrationEula,
  sendRegistrationIdentityCode,
  verifyRegistrationIdentityCode,
  createAccount,
  clearRegistrationProcess,
};
